import { createContext } from "react";

export const AgeContext = createContext({
  ages: [],
  age: {},
  sports: [],
});
